import { sleepInMs } from "@oefr/utils/sleepInMs"

// Utility function to execute a promise with a minimum delay
export const executePromiseWithDelay = async <T>(
    promiseFunc: () => Promise<T>,
    delayTime: number
): Promise<T> => {
    // Run both the passed promise and the delay in parallel
    const [result] = await Promise.all([
        promiseFunc(), // Execute the given promise function
        sleepInMs(delayTime), // Introduce the delay
    ])

    return result
}
